export enum AnimationState {
  IDLE = "idle",
  SACRIFICE = "sacrifice",
  FRONT_IDLE = "frontIdle",
}
